import 'bootstrap/scss/bootstrap.scss';
import '../styles/poppins.scss';
import '../styles/notosans.scss';
import '../styles/globals.scss';
import { Provider, useSelector } from 'react-redux';
import store from '../store';
import { toast } from 'react-toastify';
import withRedux from 'next-redux-wrapper';
import Layout from '../src/dashboard/Layout';
import { Router, withRouter } from 'next/router';
import { CurrentPageProvider } from '../src/Context/CurrentPageContext';
import { ErrorProvider } from '../src/Context/ErrorContext';
import '../src/Components/User/User.scss';
import '../src/Components/Users/Users.scss';
import '../src/Components/ThankYou/ThankYou.scss';
import '../src/Components/Table/Table.scss';
import '../src/Components/Partners/Partners.scss';
import '../src/Components/PageHead/PageHead.scss';
import '../src/Components/Orders/Orders.scss';
import '../src/Components/Nav/Nav.scss';
import '../src/Components/MerchantView/MerchantView.scss';
import '../src/Components/MarketPlaces/MarketPlaces.scss';
import '../src/Components/HowItWorks/HowItWorks.scss';
import '../src/Components/Header/Header.scss';
import '../src/Components/Footer/Footer.scss';
import '../src/Components/DateRange/DateRange.scss';
import '../src/Components/Counter/Counter.scss';
import '../src/Components/Contact/ContactUsForm.scss';
import '../src/Components/RefundModal/RefundModal.scss';
import '../src/Components/Refund/chargeback.scss';
import '../src/utils/reuseTable.scss';
import '../src/utils/checkRadioInputs.scss';
import '../src/Components/Transactions/transaction.scss';
import '../src/Components/Roles/roles.scss';
import '../src/Components/merchants/merchantGeneral/merchantEdit.scss';
import '../src/Components/merchants/merchantTimeline/timeline.scss';
import '../src/Components/Customer/customerView.scss';
import '../src/Components/Customer/table.scss';
import '../src/Components/pincodeSetting/pincodeSetting.scss';
import 'react-tabs/style/react-tabs.scss'; // css-> scss
import '../src/utils/scss/main.scss';
import '../src/utils/doubleCheckModal.scss';
import '../src/Components/merchants/isActiveConformation.scss';
import '../src/utils/radioInput.scss';
import '../src/Components/merchants/merchantConfig/netbanking/netbankingTable.scss';
import 'react-toastify/scss/main.scss';
import '../src/Components/merchants/merchantConfig/config.scss';
import '../src/Components/merchants/merchantABC/merchantABC.scss';
import '../src/Components/merchants/merchantCredentials/merchantCredentials.scss';
import '../src/Components/Orders/orderDetials.scss';
import '../src/Components/merchants/merchantDiscount/merchantDiscount.scss';
import '../src/Components/AddressAnnotation/addressAnnotationForm.scss';
import '../src/Components/PaymentProviderSwitch/paymentProviderSwitch.scss';
import '../src/Components/merchants/NewConfig/newConfig.scss';
import '../src/Components/merchants/NewConfig/PaymentPageUIControls/paymentPageUIControls.scss';
import '../src/Components/merchants/Webhooks/webhook.scss';
import '../src/Components/Checkout&PaymentAlerts/Checkout&PaymentAlerts.scss';
import '../src/Components/PaymentConfig/PaymentConfig.scss';
import '../src/Components/merchants/NewConfig/OnplControls/onplConfigControls.scss';
import '../src/Components/merchants/NewConfig/RedirectionConfigControls/redirectionConfigControls.scss';

import 'prismjs/themes/prism.css';

import axios from 'axios';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
// import { Snackbar } from "@material/react-snackbar";
import { Logout } from '../store/actions/login';
import { RefundModalProvider } from '../src/Context/RefundModalContext';
if (process.env.NODE_ENV === 'production') {
  console.warn = () => {};
  console.log = () => {};
}

function GokwikApp(props) {
  const { Component, router, deviceType } = props;
  // const [errMessage, setErrMessage] = useState(null);
  const [loader, setLoader] = useState({ count: 0, text: '' });
  const userRole = useSelector((state) => state.user.roleName);
  useEffect(() => {
    if (userRole === 'External CRM' && !router.asPath.includes('address/annotation'))
      router.push('/address/annotation');
  }, [router.asPath, userRole]);
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      (successfulReq) => {
        const token = localStorage.getItem('token');
        const { authorization, Authorization } = successfulReq.headers;
        successfulReq.headers = {
          ...successfulReq.headers,
          'X-Content-Type-Options': 'nosniff',
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'X-XSS-Protection': '1; mode=block',
          'Content-Security-Policy': `frame-ancestors 'self' https://bpoconvergence.com/`,
          ...(process.env.NODE_ENV !== 'development' && {
            'Strict-Transport-Security': 'max-age=31536000 ; includeSubDomains',
          }),
          ...(!(Authorization || authorization) && token && { authorization: token }),
        };
        if (successfulReq.url.includes('/api/utility/upload') || successfulReq?.params?.skipLoader)
          return successfulReq;

        let text = '';
        const progressNumerator =
          successfulReq.params?.page * successfulReq.params?.pageSize > successfulReq.total
            ? successfulReq.total
            : successfulReq.params?.page * successfulReq.params?.pageSize;
        if (successfulReq.download === 'download')
          text = `Fetching data ${progressNumerator} / ${Math.floor(successfulReq.total)}`;
        else if (successfulReq.upload === 'upload')
          text = `Uploading data ${progressNumerator} / ${Math.floor(successfulReq.total)}`;
        else if (successfulReq.delete === 'delete')
          text = `Deleting previous data ${progressNumerator} / ${Math.floor(successfulReq.total)}`;
        else text = successfulReq.method === 'get' ? 'Fetching Data' : 'Saving Data';

        setLoader((prev) => ({
          count: prev.count + 1,
          text,
        }));

        return successfulReq;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    let showIpMessage = false;
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        if (!response?.config?.params?.skipLoader && !response?.config?.url?.includes('/api/utility/upload'))
          setLoader((prev) => ({ ...prev, count: prev.count - 1 }));
        return response;
      },
      (error) => {
        const config = error?.config;
        if (!config?.params?.skipLoader && !config?.url?.includes('/api/utility/upload'))
          setLoader((prev) => ({ ...prev, count: prev.count - 1 }));
        if (error && error.response && error.response.data && error.response.data.status_code === 401) {
          localStorage.setItem('token', '');
          router.push('/login');
          if (!showIpMessage && error?.response?.data?.message.includes('IP address')) {
            setTimeout(() => {
              toast.error(error?.response?.data?.message, {
                position: 'top-center',
                autoClose: 3000,
              });
              showIpMessage = false;
            }, 100);
            showIpMessage = true;
          } 
          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  const [permissions, setPermissions] = useState(null);
  store.subscribe(() => {
    setPermissions(store.getState().user.permissions);
  });

  return (
    <Provider store={store}>
      {loader.count > 0 && (
        <div className='loader-container-root'>
          <div className='loader-icon-root'>
            <div className='loader'></div>
            <div className='loader-text-root'>{loader.text}</div>
          </div>
        </div>
      )}
      {/* {errMessage && (
        <Snackbar
          message={errMessage}
          onClose={() => {
            // setErrMessage(null);
          }}
          className="err-snackbar"
          timeoutMs={4000}
        />
      )} */}
      {getRootApp(Component, props, router.asPath, deviceType, permissions)}
    </Provider>
  );
}

const getRootApp = (Component, props, path, deviceType, permissions) => {
  if (permissions) {
    const checkPermission = (pathKeyword, permissionName, checkEqual) =>
      (checkEqual ? `/${pathKeyword}` === path : path.indexOf(pathKeyword) !== -1) &&
      permissions.indexOf(permissionName) === -1;
    let restrict = [
      checkPermission('', 'view_dashboard', true),
      checkPermission('orders', 'view_order'),
      checkPermission('users', 'view_users'),
      checkPermission('transaction', 'view_transactions'),
      checkPermission('customer', 'view_customers'),
      checkPermission('role', 'view_roles'),
      checkPermission('merchant', 'view_merchant'),
      checkPermission('merchants/edit', 'update_merchant'),
      checkPermission('permission', 'view_permissions'),
      checkPermission('address', 'view_address_annotation', true),
      checkPermission('address/annotation', 'ex_crm_address_annotation'),
      checkPermission('abandoned-cart', 'view_abandoned_cart'),
      checkPermission('reports', 'view_reports'),
      checkPermission('billing', 'view_billing'),
    ];
    if (restrict.indexOf(true) !== -1)
      return (
        <div className='displayFlex'>
          <h6 className='unauthorized-text'>You are not authorized to access this page</h6>
        </div>
      );
  }
  if (
    path.indexOf('login') != -1 ||
    path.indexOf('signup') != -1 ||
    path.indexOf('password') != -1 ||
    path.indexOf('otp') != -1
  ) {
    return (
      <CurrentPageProvider>
        <RefundModalProvider>
          <ErrorProvider>
            <Component {...props} />
          </ErrorProvider>
        </RefundModalProvider>
      </CurrentPageProvider>
    );
  }
  return (
    <CurrentPageProvider>
      <RefundModalProvider>
        <Layout path={path} deviceType={deviceType}>
          <ErrorProvider>
            <Component {...props} />
          </ErrorProvider>
        </Layout>
      </RefundModalProvider>
    </CurrentPageProvider>
  );
};

GokwikApp.getInitialProps = async (appContext) => {
  let userAgent = {};
  const req = appContext.ctx.req;

  if (req) userAgent = req.headers['user-agent'];
  else userAgent = navigator.userAgent;

  let isMobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile/i));

  return { deviceType: isMobile ? 'mobile' : 'desktop' };
};

//makeStore function that returns a new store for every request
const makeStore = () => store;

//withRedux wrapper that passes the store to the App Component
// export default withRedux(makeStore)(GokwikApp);
export default withRedux(makeStore)(withRouter(GokwikApp));
